(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const isProductMediaGallery = (component) =>
    Boolean(component.closest(
      'media-gallery, .product__media-wrapper, .product-media-container, [id*="MediaGallery"], [id^="GalleryViewer-"]'
    ));

  const removeHints = (component) => {
    component.querySelectorAll('.tgl-swipe-hint').forEach((hint) => hint.remove());
    component.classList.remove('tgl-has-swipe-hint');
  };

  const getSingleHint = (component) => {
    const hints = [...component.querySelectorAll('.tgl-swipe-hint')];
    const hint = hints.shift() || null;
    hints.forEach((duplicate) => duplicate.remove());
    return hint;
  };

  const setHintState = (hint, scroller) => {
    if (!hint || !scroller) return;
    const atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 8;
    hint.classList.toggle('is-at-end', atEnd);
  };

  const enhance = (root = document) => {
    if (!mobileQuery.matches) return;

    root.querySelectorAll('slider-component').forEach((component) => {
      if (isProductMediaGallery(component)) {
        removeHints(component);
        return;
      }

      let existingHint = getSingleHint(component);
      const sliders = [...component.querySelectorAll('.slider--tablet, .slider--mobile, .slider')];
      const scroller = sliders.find((element) => {
        const style = window.getComputedStyle(element);
        return element.offsetParent !== null &&
          element.scrollWidth > element.clientWidth + 12 &&
          style.display !== 'none';
      });

      if (!scroller) {
        // A hidden category keeps its hint and bound touch/scroll listeners.
        if (component.closest('tab-switcher[data-tgl-instant-tabs]') &&
            sliders.some((element) => element.offsetParent === null)) return;
        removeHints(component);
        return;
      }

      let hint = existingHint;
      if (!hint) {
        hint = document.createElement('div');
        hint.className = 'tgl-swipe-hint';
        hint.setAttribute('aria-hidden', 'true');
        scroller.before(hint);
      }

      component.classList.add('tgl-has-swipe-hint');
      hint.innerHTML = '<div class="tgl-swipe-hint__arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 16" aria-hidden="true" focusable="false"><path d="M26 8H6m0 0 5-5M6 8l5 5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>';

      if (scroller.dataset.tglSwipeHintBound === 'true') {
        setHintState(hint, scroller);
        return;
      }
      scroller.dataset.tglSwipeHintBound = 'true';

      scroller.addEventListener('touchstart', () => {
        getSingleHint(component)?.classList.add('is-touching');
      }, { passive: true });

      scroller.addEventListener('touchend', () => {
        const currentHint = getSingleHint(component);
        currentHint?.classList.remove('is-touching');
        setHintState(currentHint, scroller);
      }, { passive: true });

      scroller.addEventListener('touchcancel', () => {
        const currentHint = getSingleHint(component);
        currentHint?.classList.remove('is-touching');
        setHintState(currentHint, scroller);
      }, { passive: true });

      scroller.addEventListener('scroll', () => {
        setHintState(getSingleHint(component), scroller);
      }, { passive: true });

      setHintState(hint, scroller);
    });
  };

  const scheduleEnhance = (root = document) => {
    window.requestAnimationFrame(() => window.setTimeout(() => enhance(root), 120));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleEnhance());
  } else {
    scheduleEnhance();
  }

  document.addEventListener('shopify:section:load', (event) => scheduleEnhance(event.target));
  document.addEventListener('change', (event) => {
    if (event.target.matches('tab-switcher input[type="radio"]')) {
      // Build the hint in the same event, before the browser paints the new tab.
      enhance(event.target.closest('tab-switcher'));
    }
  });

  const observer = new MutationObserver((mutations) => {
    if (!mobileQuery.matches) return;
    const needsRefresh = mutations.some((mutation) =>
      mutation.target.matches?.('[data-recently-viewed-list]') ||
      [...mutation.addedNodes].some((node) =>
        node.nodeType === 1 && (
          node.matches?.('product-recommendations, slider-component') ||
          node.querySelector?.('product-recommendations, slider-component')
        )
      )
    );
    if (needsRefresh) scheduleEnhance();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  mobileQuery.addEventListener?.('change', () => {
    if (!mobileQuery.matches) {
      document.querySelectorAll('slider-component.tgl-has-swipe-hint').forEach(removeHints);
      return;
    }
    scheduleEnhance();
  });
})();